import { render, staticRenderFns } from "./_providerPtGlobal.vue?vue&type=template&id=ea18af3c&lang=pug"
import script from "./_providerPtGlobal.vue?vue&type=script&lang=js"
export * from "./_providerPtGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports